import React, { useState } from 'react';
import { Tooltip, Modal, ModalBody, ModalHeader, ModalFooter, Table, Button } from 'reactstrap';
import Speech from 'speak-tts';

export default function TooltipItem(props) {
	const { item, id } = props;
	const [tooltipOpen, setTooltipOpen] = useState(false);
	const [modal, setModal] = useState(false);
	const [showDetails, setShowDetails] = useState(false);

	const toggle = () => setTooltipOpen(!tooltipOpen);
	const toggleModal = () => setModal(!modal);
	

	// const showDetailsPopup = () => {
	// 	setShowDetails(true);
	// }
	const showDetailsPopup = () => {
		if (item.class === 'pause-info') return;
		setShowDetails(true);
	};

	const closePopup = () => {
		setShowDetails(false);
	}


	const phonemes = (details) => {
	if (!Array.isArray(details)) return null;
	return (
		<>
		{details.map((detail, i) => {
			let class_name = 'color-success';
			if (detail.decision === 'error') class_name = 'color-danger';
			else if (detail.decision === 'incorrect')
			class_name = detail.nativeness_score > 30 ? 'color-warning' : 'color-danger';
			else if (detail.decision === 'warning') class_name = 'color-warning';

			const text = detail.decision === 'correct' ? 'Excellent' : 'Incorrect.';
			const feedback = 'feedback' in detail ? detail.feedback : null;

			return (
			<div className="row" key={i}>
				<div className="col-lg-4">
				/{detail.trans ?? detail.ipa}/
				</div>
				<div className="col-lg-8">
				<span className={class_name}>{text}</span>
				{feedback && (
					<>
					<br />
					<span className="word-feedback">{feedback}</span>
					</>
				)}
				</div>
			</div>
			);
		})}
		</>
	);
	};

	const gatheredPhonemes = (details) => {
	if (!Array.isArray(details)) return null;
	return (
		<>
		{details.map((detail, i) => {
			let class_name = 'color-success';
			if (detail.decision === 'error') class_name = 'color-danger';
			else if (detail.decision === 'incorrect')
			class_name = detail.nativeness_score > 30 ? 'color-warning' : 'color-danger';
			else if (detail.decision === 'warning') class_name = 'color-warning';

			return (
			<span className={class_name} key={i}>
				{detail.trans ?? detail.ipa}
			</span>
			);
		})}
		</>
	);
	};


	const wordPronunce = (e, word) => {
		const speech = new Speech();
		speech.speak({
			text: word
		});
	}


	return (
    <>
      <span
        className={`${item.class} tooltip-word`}
        id={`Tooltip-${id}`}
        onClick={showDetailsPopup}
		style={{ cursor: item.class === 'pause-info' ? 'default' : 'pointer' }}
      >
        {item.word !== "&nbsp;" ? item.word : " "}
      </span>
      {item.word !== "&nbsp;" && "word_score" in item && (
        <Tooltip
          placement="top"
          isOpen={tooltipOpen}
          target={"Tooltip-" + id}
          toggle={toggle}
        >
          Word Score
          <br />
          <b className={item.class}>{parseInt(item.word_score)}</b> / 100
        </Tooltip>
      )}

      {"details" in item && (
        <Modal
          className="word-details-modal"
          isOpen={showDetails}
          size="md"
          toggle={toggleModal}
        >
          		{/* <ModalBody className="word-details">
						<div className="popup-header text-center mb-1">
							<span className="normal-word float-left">\<i className={item.class}>{item.word.trim()}</i>\</span>
							<span className="word-ipa">\{gatheredPhonemes(item.details)}\</span>
							<span
								className="word-pronunciation float-right"
								onClick={(e) => wordPronunce(e, item.word.trim())}
							>
								<i className="fa fa-bullhorn" aria-hidden="true"></i>
							</span>
						</div>
						<div className="details-popup">
							<div className="col popup-content">
								<div className="row popup-content-heading">
									<div className="col-lg-4">Sound</div>
									<div className="col-lg-8">You said</div>
								</div>
								<div className="popup-content-data">
									{phonemes(item.details)}
								</div>
							</div>
						</div>
					</ModalBody> */}
					<ModalBody className="word-details">
						{item.details ? (
						<>
							<div className="popup-header text-center mb-1">
							<span className="normal-word float-left">
								<i className={item.class}>{item.word.trim()}</i>
							</span>
							<span className="word-ipa">
								\{gatheredPhonemes(item.details)}\
							</span>
							<span
								className="word-pronunciation float-right"
								onClick={(e) => wordPronunce(e, item.word.trim())}
							>
								<i className="fa fa-bullhorn" aria-hidden="true"></i>
							</span>
							</div>

							<div className="details-popup">
							<div className="col popup-content">
								<div className="row popup-content-heading">
								<div className="col-lg-4">Sound</div>
								<div className="col-lg-8">You said</div>
								</div>
								<div className="popup-content-data">
								{phonemes(item.details)}
								</div>
							</div>
							</div>
						</>
						) : (
						// 🔻 fallback when item.details is empty or undefined
						<div className="text-center py-3">
							<span className={item.class}>
							{item.word || "Unable to recognize your voice"}
							</span>
						</div>
						)}
					</ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              className="modalCloseBtn"
              onClick={closePopup}
            >
              Close
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </>
  );
}